angular.module("EMR.EhrSelectOutsideDoctorsSharedModule", []);